import { useStore, useUnit } from 'effector-react';
import $$dropdowns from 'models/dropdowns';
import { $isHeaderlessPage } from 'models/location';
import { $global } from 'models/store-global';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Frame } from './StyledTemplates';

import useOnClickOutside from 'hooks/useOnClickOutside';

import iconHamburger from 'assets/icons/hamburger.svg';

import { type DropdownName } from 'types/zod/dropdown-name';

type IconProps = {
    id?: DropdownName;
} & React.HTMLAttributes<HTMLDivElement>;

const Icon = (props: IconProps) => {
    const { id = 'hamburger', className = '' } = props;
    return <Styles.Icon className={className} onClick={() => $$dropdowns.toggle(id)} />;
};

type SidebarMenuProps = {
    id?: DropdownName;
    navMenuContent: () => JSX.Element;
    menu: () => JSX.Element;
} & React.HTMLAttributes<HTMLDivElement>;

const SidebarMenu = (props: SidebarMenuProps) => {
    const ref = useRef();
    const { id = 'hamburger', className = '', navMenuContent: NavMenuContent, menu: Menu } = props;
    const user = useUnit($global.map((state) => state.auth?.user));
    const opened = useUnit($$dropdowns.$opened.map((opened) => opened.includes(id)));
    const { pathname } = useLocation();
    const handlers = {
        closeSidebar: () => {
            $$dropdowns.close(id);
        },
    };
    useOnClickOutside(ref, handlers.closeSidebar);
    useEffect(handlers.closeSidebar, [pathname]);

    const isHeaderlessPage = useStore($isHeaderlessPage);

    return (
        <Styles.Menu ref={ref} $opened={opened} className={className}>
            {user?.attributes && (
                <Frame extra="width: 100%; height: max-content;">
                    <Menu />
                </Frame>
            )}
            {!isHeaderlessPage && <NavMenuContent />}
        </Styles.Menu>
    );
};

const Styles = {
    Icon: styled.img.attrs((props) => ({
        ...props,
        src: iconHamburger,
    }))`
        width: 24px;
        height: 24px;
    `,
    Menu: styled(Frame).attrs((props) => ({
        ...props,
        className: 'hamburger' as string,
    }))<{ $opened?: boolean; ref: any }>`
        position: fixed;
        top: 0;
        right: 0;
        width: 70vw;
        height: 100%;
        background-color: #ffffff;
        z-index: 9999;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        transform: translateX(${({ $opened = false }) => ($opened ? '0' : '100%')});
        box-shadow: -3px 0px 12px rgba(0, 0, 0, ${({ $opened = false }) => ($opened ? '0.08' : '0')});
        flex: 1;
        display: flex;
        overflow: auto;
        ::-webkit-scrollbar {
            display: none;
        }
    `,
};

const Hamburger = {
    Icon,
    SidebarMenu,
};

export default Hamburger;
